import React, { Suspense, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import routes from "./routes";
import "../src/common/common_css/Common_css.css";
import "../src/common/common_css/Form_Css.css";
import { Spinner } from "react-bootstrap";
import Reports_Generation from "./components/header_components/reports_generation/Reports_Generation";
import Quality_Management from "./components/header_components/quality_management/Quality_Management";
import User_Management_Page from "./components/header_components/user_management_page/User_Management_Page";

function App({}) {
  const location = useLocation();
  return (
    <>
      <section className="desktop_container">
         {location.pathname !== "/login" && <Header />}
        <Suspense
          fallback={
            <div className="pt-3 text-center">
              <Spinner
                animation="grow"
                variant="primary"
                style={{
                  width: "4rem",
                  height: "4rem",
                  color: "#fbca06",
                  background: "#fbca06",
                }}
              />
            </div>
          }
        >
          <Routes>
            {routes.map((route, idx) => {
              return (
                route.element && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element />}
                  />
                )
              );
            })}
            <Route
              path="/reports-generation/*"
              element={<Reports_Generation />}
            ></Route>
            <Route
              path="/quality-management/*"
              element={<Quality_Management />}
            ></Route>
            <Route
              path="/user-management/*"
              element={<User_Management_Page />}
            ></Route>
          </Routes>
        </Suspense>
      </section>

      <section className="mobile_container">
        <div className="logo">
          <div className="logo_holder">
            <img
              src={
                process.env.PUBLIC_URL + "/favicon.png"
              }
              alt="ultimate-logo"
              className="ultimate-logo"
            />
          </div>
        </div>
        <h2>The page you are viewing is not compatible with mobile.</h2>
        <p>
          To access the page, please select the <strong>'Desktop Site'</strong>{" "}
          in the browser menu or use a <strong>desktop/laptop</strong>.
        </p>
      </section>
    </>
  );
}

export default App;
